export const AppConstants = {
  Pagination: {
    StartingPage: 1,
    PageSize: 10,
  },
};

export enum AppUserRoles {
  SuperAdmin = "SuperAdmin",
  Admin = "Admin",
}

export enum AppUserDepartment {
  FinanceManager = "FinanceManager",
  HrOfficer = "HrOfficer",
  Admin = "Admin",
}

export const Days = [
  "Saturday",
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
];

export const DHS_INSURANCE_NAME = "DHS/Medicaid";

export enum SearchQueryParams{
  FromDate="fromDate",
  ToDate="toDate",
  AppointmentStatus="appointmentStatus",
  InvoiceStatus="invoiceStatus"
}